import { ArrowRightIcon, DoubleArrowRightIcon } from '@radix-ui/react-icons';
import { Box, Card, Flex, Grid, Heading, IconPanel, Inset, ProviderIcon, Text } from '@workos-inc/design-system';
import NextLink from 'next/link';
const SsoIntegrationCards = () => <Grid columns={{
  sm: '2'
}} gap="5" mb="6" mt="5" data-sentry-element="Grid" data-sentry-component="SsoIntegrationCards" data-sentry-source-file="provider-cards.tsx">
    <Card asChild size="3" data-sentry-element="Card" data-sentry-source-file="provider-cards.tsx">
      <NextLink href="/integrations/okta-saml" data-sentry-element="NextLink" data-sentry-source-file="provider-cards.tsx">
        <Flex align="center" gap="5" justify="between" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
          <Box data-sentry-element="Box" data-sentry-source-file="provider-cards.tsx">
            <Heading as="h3" mb="1" size="3" trim="start" data-sentry-element="Heading" data-sentry-source-file="provider-cards.tsx">
              Okta SAML
            </Heading>
            <Text as="p" color="gray" size="2" trim="end" data-sentry-element="Text" data-sentry-source-file="provider-cards.tsx">
              Configure a connection to Okta via SAML.
            </Text>
          </Box>

          <IconPanel size="3" data-sentry-element="IconPanel" data-sentry-source-file="provider-cards.tsx">
            <ProviderIcon provider="okta" size="3" data-sentry-element="ProviderIcon" data-sentry-source-file="provider-cards.tsx" />
          </IconPanel>
        </Flex>
      </NextLink>
    </Card>

    <Card asChild size="3" data-sentry-element="Card" data-sentry-source-file="provider-cards.tsx">
      <NextLink href="/integrations/entra-id-saml" data-sentry-element="NextLink" data-sentry-source-file="provider-cards.tsx">
        <Flex align="center" gap="5" justify="between" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
          <Box data-sentry-element="Box" data-sentry-source-file="provider-cards.tsx">
            <Heading as="h3" mb="1" size="3" trim="start" data-sentry-element="Heading" data-sentry-source-file="provider-cards.tsx">
              Entra ID (Azure AD) SAML
            </Heading>
            <Text as="p" color="gray" size="2" trim="end" data-sentry-element="Text" data-sentry-source-file="provider-cards.tsx">
              Configure an Entra ID SAML connection.
            </Text>
          </Box>

          <IconPanel size="3" data-sentry-element="IconPanel" data-sentry-source-file="provider-cards.tsx">
            <ProviderIcon provider="microsoft" size="3" data-sentry-element="ProviderIcon" data-sentry-source-file="provider-cards.tsx" />
          </IconPanel>
        </Flex>
      </NextLink>
    </Card>

    <Card asChild size="3" data-sentry-element="Card" data-sentry-source-file="provider-cards.tsx">
      <NextLink href="/integrations/google-saml" data-sentry-element="NextLink" data-sentry-source-file="provider-cards.tsx">
        <Flex align="center" gap="5" justify="between" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
          <Box data-sentry-element="Box" data-sentry-source-file="provider-cards.tsx">
            <Heading as="h3" mb="1" size="3" trim="start" data-sentry-element="Heading" data-sentry-source-file="provider-cards.tsx">
              Google Workspace SAML
            </Heading>
            <Text as="p" color="gray" size="2" trim="end" data-sentry-element="Text" data-sentry-source-file="provider-cards.tsx">
              Configure a Google Workspace SAML connection.
            </Text>
          </Box>

          <IconPanel size="3" data-sentry-element="IconPanel" data-sentry-source-file="provider-cards.tsx">
            <ProviderIcon provider="google" size="3" data-sentry-element="ProviderIcon" data-sentry-source-file="provider-cards.tsx" />
          </IconPanel>
        </Flex>
      </NextLink>
    </Card>

    <Card asChild size="3" data-sentry-element="Card" data-sentry-source-file="provider-cards.tsx">
      <NextLink href="/integrations" data-sentry-element="NextLink" data-sentry-source-file="provider-cards.tsx">
        <Flex align="center" gap="5" justify="between" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
          <Box data-sentry-element="Box" data-sentry-source-file="provider-cards.tsx">
            <Heading as="h3" mb="1" size="3" trim="start" data-sentry-element="Heading" data-sentry-source-file="provider-cards.tsx">
              <Flex align="center" gap="1" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
                All integrations{' '}
                <ArrowRightIcon height="16" style={{
                marginTop: 1
              }} width="16" data-sentry-element="ArrowRightIcon" data-sentry-source-file="provider-cards.tsx" />
              </Flex>
            </Heading>
            <Text as="p" color="gray" size="2" trim="end" data-sentry-element="Text" data-sentry-source-file="provider-cards.tsx">
              Choose from dozens of other identity providers.
            </Text>
          </Box>
        </Flex>
      </NextLink>
    </Card>
  </Grid>;
const DirSyncIntegrationCards = () => <Grid columns={{
  sm: '2'
}} gap="5" mb="6" mt="5" data-sentry-element="Grid" data-sentry-component="DirSyncIntegrationCards" data-sentry-source-file="provider-cards.tsx">
    <Card asChild size="3" data-sentry-element="Card" data-sentry-source-file="provider-cards.tsx">
      <NextLink href="/integrations/okta-scim" data-sentry-element="NextLink" data-sentry-source-file="provider-cards.tsx">
        <Flex align="center" gap="5" justify="between" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
          <Box data-sentry-element="Box" data-sentry-source-file="provider-cards.tsx">
            <Heading as="h3" mb="1" size="3" trim="start" data-sentry-element="Heading" data-sentry-source-file="provider-cards.tsx">
              Okta
            </Heading>
            <Text as="p" color="gray" size="2" trim="end" data-sentry-element="Text" data-sentry-source-file="provider-cards.tsx">
              Configure a directory connection to Okta.
            </Text>
          </Box>

          <IconPanel size="3" data-sentry-element="IconPanel" data-sentry-source-file="provider-cards.tsx">
            <ProviderIcon provider="okta" size="3" data-sentry-element="ProviderIcon" data-sentry-source-file="provider-cards.tsx" />
          </IconPanel>
        </Flex>
      </NextLink>
    </Card>

    <Card asChild size="3" data-sentry-element="Card" data-sentry-source-file="provider-cards.tsx">
      <NextLink href="/integrations/entra-id-scim" data-sentry-element="NextLink" data-sentry-source-file="provider-cards.tsx">
        <Flex align="center" gap="5" justify="between" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
          <Box data-sentry-element="Box" data-sentry-source-file="provider-cards.tsx">
            <Heading as="h3" mb="1" size="3" trim="start" data-sentry-element="Heading" data-sentry-source-file="provider-cards.tsx">
              Entra ID (Azure AD)
            </Heading>
            <Text as="p" color="gray" size="2" trim="end" data-sentry-element="Text" data-sentry-source-file="provider-cards.tsx">
              Configure an Entra ID directory connection.
            </Text>
          </Box>

          <IconPanel size="3" data-sentry-element="IconPanel" data-sentry-source-file="provider-cards.tsx">
            <ProviderIcon provider="microsoft" size="3" data-sentry-element="ProviderIcon" data-sentry-source-file="provider-cards.tsx" />
          </IconPanel>
        </Flex>
      </NextLink>
    </Card>

    <Card asChild size="3" data-sentry-element="Card" data-sentry-source-file="provider-cards.tsx">
      <NextLink href="/integrations/google-directory-sync" data-sentry-element="NextLink" data-sentry-source-file="provider-cards.tsx">
        <Flex align="center" gap="5" justify="between" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
          <Box data-sentry-element="Box" data-sentry-source-file="provider-cards.tsx">
            <Heading as="h3" mb="1" size="3" trim="start" data-sentry-element="Heading" data-sentry-source-file="provider-cards.tsx">
              Google Workspace
            </Heading>
            <Text as="p" color="gray" size="2" trim="end" data-sentry-element="Text" data-sentry-source-file="provider-cards.tsx">
              Configure a Google Workspace directory connection.
            </Text>
          </Box>

          <IconPanel size="3" data-sentry-element="IconPanel" data-sentry-source-file="provider-cards.tsx">
            <ProviderIcon provider="google" size="3" data-sentry-element="ProviderIcon" data-sentry-source-file="provider-cards.tsx" />
          </IconPanel>
        </Flex>
      </NextLink>
    </Card>

    <Card asChild size="3" data-sentry-element="Card" data-sentry-source-file="provider-cards.tsx">
      <NextLink href="/integrations" data-sentry-element="NextLink" data-sentry-source-file="provider-cards.tsx">
        <Flex align="center" gap="5" justify="between" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
          <Box data-sentry-element="Box" data-sentry-source-file="provider-cards.tsx">
            <Heading as="h3" mb="1" size="3" trim="start" data-sentry-element="Heading" data-sentry-source-file="provider-cards.tsx">
              <Flex align="center" gap="1" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
                All integrations{' '}
                <ArrowRightIcon height="16" style={{
                marginTop: 1
              }} width="16" data-sentry-element="ArrowRightIcon" data-sentry-source-file="provider-cards.tsx" />
              </Flex>
            </Heading>
            <Text as="p" color="gray" size="2" trim="end" data-sentry-element="Text" data-sentry-source-file="provider-cards.tsx">
              Choose from dozens of other directory providers.
            </Text>
          </Box>
        </Flex>
      </NextLink>
    </Card>
  </Grid>;
const UserManagementMigrationCards = () => <Grid columns={{
  xs: '2'
}} gap="5" mb="6" mt="5" data-sentry-element="Grid" data-sentry-component="UserManagementMigrationCards" data-sentry-source-file="provider-cards.tsx">
    <Card asChild size="1" data-sentry-element="Card" data-sentry-source-file="provider-cards.tsx">
      <NextLink href="/migrate/auth0" data-sentry-element="NextLink" data-sentry-source-file="provider-cards.tsx">
        <Inset clip="padding-box" data-sentry-element="Inset" data-sentry-source-file="provider-cards.tsx">
          <Flex height="160px" justify="center" style={{
          background: '#f5f5f6'
        }} data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
            <img alt="" src="https://images.workoscdn.com/images/4a16b2e6-76a8-43e5-8210-aaa56e36508b.png?auto=format&fit=clip&q=80" style={{
            display: 'block',
            height: '100%'
          }} />
          </Flex>

          <Flex align="center" gap="5" justify="between" p="4" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
            <Box data-sentry-element="Box" data-sentry-source-file="provider-cards.tsx">
              <Heading as="h3" mb="1" size="3" trim="start" data-sentry-element="Heading" data-sentry-source-file="provider-cards.tsx">
                Auth0
              </Heading>
              <Text as="p" color="gray" size="2" trim="end" data-sentry-element="Text" data-sentry-source-file="provider-cards.tsx">
                Learn how to migrate users and organizations from Auth0.
              </Text>
            </Box>

            <ProviderIcon mr="2" provider="auth0" size="3" data-sentry-element="ProviderIcon" data-sentry-source-file="provider-cards.tsx" />
          </Flex>
        </Inset>
      </NextLink>
    </Card>
    <Card asChild size="1" data-sentry-element="Card" data-sentry-source-file="provider-cards.tsx">
      <NextLink href="/migrate/aws-cognito" data-sentry-element="NextLink" data-sentry-source-file="provider-cards.tsx">
        <Inset clip="padding-box" data-sentry-element="Inset" data-sentry-source-file="provider-cards.tsx">
          <Flex height="160px" justify="center" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
            <img alt="" src="https://images.workoscdn.com/images/68c9d1c4-650c-4b66-b05d-1ee832a730fb.png?auto=format&fit=clip&q=80" style={{
            objectFit: 'cover',
            display: 'block',
            height: '100%',
            width: '100%'
          }} />
          </Flex>

          <Flex align="center" gap="5" justify="between" p="4" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
            <Box data-sentry-element="Box" data-sentry-source-file="provider-cards.tsx">
              <Heading as="h3" mb="1" size="3" trim="start" data-sentry-element="Heading" data-sentry-source-file="provider-cards.tsx">
                AWS Cognito
              </Heading>
              <Text as="p" color="gray" size="2" trim="end" data-sentry-element="Text" data-sentry-source-file="provider-cards.tsx">
                Learn how to migrate users to WorkOS from AWS Cognito.
              </Text>
            </Box>

            <ProviderIcon mr="2" provider="aws" size="3" data-sentry-element="ProviderIcon" data-sentry-source-file="provider-cards.tsx" />
          </Flex>
        </Inset>
      </NextLink>
    </Card>
    <Card asChild size="1" data-sentry-element="Card" data-sentry-source-file="provider-cards.tsx">
      <NextLink href="/migrate/firebase" data-sentry-element="NextLink" data-sentry-source-file="provider-cards.tsx">
        <Inset clip="padding-box" data-sentry-element="Inset" data-sentry-source-file="provider-cards.tsx">
          <Flex height="160px" justify="center" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
            <img alt="" src="https://images.workoscdn.com/images/21a3d31a-97af-4984-ac83-2a194e99ce74.png?auto=format&fit=clip&q=80" style={{
            display: 'block',
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }} />
          </Flex>

          <Flex align="center" gap="5" justify="between" p="4" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
            <Box data-sentry-element="Box" data-sentry-source-file="provider-cards.tsx">
              <Heading as="h3" mb="1" size="3" trim="start" data-sentry-element="Heading" data-sentry-source-file="provider-cards.tsx">
                Firebase
              </Heading>
              <Text as="p" color="gray" size="2" trim="end" data-sentry-element="Text" data-sentry-source-file="provider-cards.tsx">
                Learn how to migrate users to WorkOS from Firebase.
              </Text>
            </Box>

            <ProviderIcon mr="2" provider="firebase" size="3" data-sentry-element="ProviderIcon" data-sentry-source-file="provider-cards.tsx" />
          </Flex>
        </Inset>
      </NextLink>
    </Card>
    <Card asChild size="1" data-sentry-element="Card" data-sentry-source-file="provider-cards.tsx">
      <NextLink href="/migrate" data-sentry-element="NextLink" data-sentry-source-file="provider-cards.tsx">
        <Flex align="center" height="100%" justify="center" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
          <Flex align="center" direction="column" gap="3" p="4" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
            <IconPanel size="3" data-sentry-element="IconPanel" data-sentry-source-file="provider-cards.tsx">
              <DoubleArrowRightIcon data-sentry-element="DoubleArrowRightIcon" data-sentry-source-file="provider-cards.tsx" />
            </IconPanel>
            <Flex align="center" direction="column" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
              <Heading as="h3" mb="1" size="3" data-sentry-element="Heading" data-sentry-source-file="provider-cards.tsx">
                <Flex align="center" gap="1" data-sentry-element="Flex" data-sentry-source-file="provider-cards.tsx">
                  View all migrations <ArrowRightIcon height="16" width="16" data-sentry-element="ArrowRightIcon" data-sentry-source-file="provider-cards.tsx" />
                </Flex>
              </Heading>
              <Text align="center" as="p" color="gray" size="2" data-sentry-element="Text" data-sentry-source-file="provider-cards.tsx">
                Migrate from a range of other services.
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </NextLink>
    </Card>
  </Grid>;
export const ProviderCards = {
  SsoIntegration: SsoIntegrationCards,
  DirSyncIntegration: DirSyncIntegrationCards,
  UserManagementMigration: UserManagementMigrationCards
};